import { ApprovalMode } from '@ebalance/proto/bfftypes/v1/approval_flow_type_pb'

import {
  type CellLocal,
  isCellIncomplete,
} from '~/pages/AdminApprovalFlow/models/reducer'

export type StageRange = { min: number; max: number }

/**
 * 一括 = 要承認 の要約に出す承認段階数の範囲 (AC-APF-003b)。
 * 承認者未設定のセル (AC-APF-070 の (a)) は数えず、 数えるセルが無ければ undefined。
 */
export function approvalStageRange(
  cells: Iterable<CellLocal | undefined>,
): StageRange | undefined {
  let range: StageRange | undefined
  for (const cell of cells) {
    if (cell?.mode !== ApprovalMode.APPROVAL || isCellIncomplete(cell)) continue
    const count = cell.stages.length
    range =
      range === undefined
        ? { min: count, max: count }
        : { min: Math.min(range.min, count), max: Math.max(range.max, count) }
  }
  return range
}
